import React from 'react';
import { Input, InputProps } from '@chakra-ui/react';

const BlgInput = ({ ...props }: InputProps) => {
  const defaultStyle: InputProps = {
    borderRadius: 'full',
    px: 4,
    bg: 'white',
    fontWeight: 700,
    color: 'darkBlue.500',
    _focusVisible: {
      borderColor: 'darkBlue.500',
    },
    _placeholder: {
      color: 'darkBlue.500',
      opacity: 0.4,
    },
  };

  return <Input {...defaultStyle} {...props} />;
};

export default BlgInput;
